import { requests } from '../../api/services';
import { LIST_DISCOVERY_PRESETS } from '../../utils/Endpoints';
import { BaseModel } from '../../model/shared/BaseModel';
import { IDiscoveryPreset } from '../../model/discovery/DiscoveryPresets';

export const DiscoveryPresetService = {
    getDiscoveryPresets: (params?: any): Promise<BaseModel<IDiscoveryPreset>> =>
        requests.get(`${LIST_DISCOVERY_PRESETS}`, params),
};
